import { render, staticRenderFns } from "./QuoteShow.vue?vue&type=template&id=73cc8488&scoped=true"
import script from "./QuoteShow.vue?vue&type=script&lang=js"
export * from "./QuoteShow.vue?vue&type=script&lang=js"
import style0 from "./QuoteShow.vue?vue&type=style&index=0&id=73cc8488&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73cc8488",
  null
  
)

export default component.exports